export default __webpack_public_path__ + "static/media/6.d89e17c1.jpg";